import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import HideOnMobile from '@anm/components/mobile/HideOnMobile';

export const CalendarHeaderMobile = media.tablet`
    flex-direction: column;
    padding: 10px 20px 0;
    align-items: center;
`;

export const CalendarTitle = styled.div`
  color: #292a2b;
  font-size: 34px;
  font-weight: 300;
  text-align: center;
  div {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    color: #919eaa;
  }
`;
export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
  padding: 20px 30px 0;
  ${CalendarHeaderMobile};
  > * {
    margin-top: 20px;
  }
`;

const CalendarWrapper = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CalendarHeaderButtons = styled(HideOnMobile)`
  button {
    margin-left: 20px;
    &:first-of-type {
      margin-left: 0;
    }
  }
`;

export default CalendarWrapper;
